export default "__VITE_ASSET__6824d7b8__"